import { makeStyles } from '@material-ui/core';

export const useBadgeStyles = makeStyles(theme => ({
  badge: {
    border: `1px solid ${theme.palette.background.paper}`
  }
}));
